module.exports = __webpack_public_path__ + "static/img/guijidian.32b607fb.png";